
import React from 'react';
import { t, validateNonEmpty } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { regionOptions } from '../data/regions';
import { commonControlsConfig } from '../utils';

const { showLabels } = DEFAULT_FORM_DATA;

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
    {
      ...sections.legacyRegularTime,
      expanded: false
    },
     {
        label: t('Query'),
        expanded: true,
        controlSetRows: [
          [
            {
              name: 'select_region',
              config: {
                type: 'SelectControl',
                label: t('Region'),
                default: null,
                choices: regionOptions,
                description: t('Which region to plot the map for?'),
                validators: [validateNonEmpty],
              },
            },
          ],
          [
            {
              name: 'groupby',
              config: {
                ...sharedControls.groupby,
                label: t('ISO 3166-2 Codes'),
                description: t(
                  'Column containing ISO 3166-2 codes of region/province/department in your table.',
                ),
                multi: false,
                clearable: false,
                validators: [validateNonEmpty]
              }
            }
          ],
          ['metric'],
          ['adhoc_filters'],
        ],
     },
     {
       label: t('Chart Options'),
       tabOverride: 'customize',
       expanded: false,
       controlSetRows: [
        //  ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
         [
           {
             name: 'show_labels',
             config: {
               type: 'CheckboxControl',
               label: t('Show Labels'),
               renderTrigger: true,
               default: showLabels,
               description: t('Whether to display the labels.'),
             },
           },
         ],

         [
          {
            name: 'tooltipFormat',
            config: {
              ...commonControlsConfig.tooltipFormat,
              default: DEFAULT_FORM_DATA.tooltipFormat,
            },
          }
         ],
         [
          {
            name: 'enableFiltering',
            config: {
              type: 'CheckboxControl',
              label: t('Enable Filtering'),
              renderTrigger: true,
              default: false,
              description: t('Whether to apply a filter on selecting a region.'),
            },
          },
        ],
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
     };
   },
   denormalizeFormData: formData => ({
     ...formData,
     metric: formData.standardizedFormData.standardizedState.metrics[0],
     groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 